import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

const setApplePayAuthtoken = (state, applePayAuthToken: string): any => ({
  ...state,
  applePayAuthToken,
})

export default createReducer((on) => {
  on(actions.setApplePayAuthtoken, setApplePayAuthtoken)
}, initialState)
